import React from 'react';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import Popover from 'material-ui/Popover';
import ContentSave from 'material-ui/svg-icons/content/save';
import ActionInfo from 'material-ui/svg-icons/action/info';
import SocialShare from 'material-ui/svg-icons/social/share';
import Menu from 'material-ui/Menu';
import _, {cloneDeep} from 'lodash';
//import MenuItem from 'material-ui/MenuItem';
import NavigationClose from 'material-ui/svg-icons/navigation/close';

import NavigationExpandMoreIcon from 'material-ui/svg-icons/navigation/expand-more';
import MenuItem from 'material-ui/MenuItem';
import DropDownMenu from 'material-ui/DropDownMenu';
import RaisedButton from 'material-ui/RaisedButton';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import FontIcon from 'material-ui/FontIcon';
import NavigationArrowDropDownCircle from 'material-ui/svg-icons/navigation/arrow-drop-down-circle';


const numeral = require('numeral');

const styles = {
	SectorCard:{
		margin:10

	},
	cardContentRow:{
	   	display: 'flex',
	    flexDirection: 'row wrap',
		marginLeft:10,
		marginRight:10,
		marginTop:'1%',
		paddingRight:14,
		backgroundColor:'white',
	},
	ToolbarGroup:{
		// flex:3,
		width:'18%',
		paddingLeft:15,
		paddingRight:15,
		height:'inherit',

	},
	ToolbarGroupPos:{
		marginLeft:20,
	},
	ToolbarGroupText:{
		flex:1,
		paddingLeft:15,
		paddingRight:15,
		fontSize:13,

	},
	ToolbarKeepBtn:{
		flex:5

	},
	flex2:{
		flex:2
	},
	flex3:{
		flex:3
	},
	ToolbarLabel:{
		color:'#333',
		textAlign:'right',
		lineHeight:2.5,
		fontSize:14,
		height:'inherit',
		fontWeight:'600',

	},
	IconButton:{
		paddingTop:5,

	},
	inputField:{
		fontSize:14,
		width:90,
		height:'inherit',

	},
	infoBtn:{
		//position:'relative',
		// right:10,
		// top:15,
		color:'#333',
		marginLeft:14,
		marginTop:5
	},
	duplicateLink:{
		fontSize:12,
		color:'#333',
		textAlign:'center',
	},
	dupIconApply:{
		color:'rgb(6, 111, 28)',
	},
	dupIconRemove:{
		color:'rgb(228, 21, 21)',
	},
	popoverInner:{
		padding:10,
		maxWidth:300
	},
	dDown:{
		marginLeft:'0px',
		height:'inherit',
		minWidth:'175px',
		label:{
			fontSize:14
		},
		labelBare: {
			fontSize: 14,
			paddingRight: 0,
			paddingLeft: 0
		},
		icon:{
			width:'19',
		},
		iconColor:{

		}
	},
	dDownPos:{
		height:'inherit',
		maxWidth:'120px'
	},
	dDownIndex: {
		height:'inherit',
		maxWidth:'160px'
	}
};

const iconStyles = {

	color: 'rgb(189, 189, 189)',
	// height:36,
	// width:36
};

const screenerFieldsFilter = {
	'market_val':[0,1],
	'indexes':[0,1],
	'moving_ave50':[0,1],
	'earning_announcement':[0,1],
	'beta':[0,1],
	'last_price':[0,1],
	'pe_ratio_12m':[0,1],
	'iad':[0,1],
	'avg_vol_20d':[0,1],
	'peg_ratio':[0,1]
}

const allScreenerFields = [
		{type:'market_val', name:'Market Cap'},
		{type:'indexes', name:'Indexes', selector: [
			{ type: 'sp500', name: "S&P 500"},
			{ type: 'russell2000', name: "Russell 2000"}
		]},
		{
			type:'moving_ave50',
			name:'Moving Ave50',
			posType: { disabled: true, default: 0 },
			notes: "Stock price is greater than moving average"
		},
		{
			type:'earning_announcement',
			name:'Earning Announcement',
			posType: { disabled: true, default: 1 },
			notes: "Screen out companies without Earning Announcements"
		},
		{type:'beta', name:'Beta'},
		{type:'last_price',name:'Last Price'},
		{type:'pe_ratio_12m',name:'P/E 12 Months'},
		{type:'iad',name:'IAD'},
		{type:'avg_vol_20d',name:'Avg Daily Vol'},
		{type:'peg_ratio',name:'PEG Ratio'},
	]



const posTypes =[
	{type:0, name:'Long'},{type:1, name:'Short'},{type:2, name:'Both'}
]


export default class ScreenerToolBar extends React.Component {

	constructor(props) {
		super(props);
		console.log("SCREENER TAB PROPS:", props)
		this.state = {
			screener:props.screener,
			needSave:false,
			openPopover:false,
			currentField: null
		};
	};

	componentDidMount = ()=>{
		this.setFieldOptions()
		if(this.props.screener.field){
			var name = this.props.screener.field
		}
		else{
			var validOptions = this.checkValidScreenerOptions();
			console.log(validOptions);
			for(var name in validOptions) {
			   console.log(name)
			   break
			}
		}

		this.onFieldSelect(null,null,name)
		if(this.props.screener.maxVal !== "" && this.props.screener.maxVal !== ""){
			this.props.count()

		}

		// this.setPosTypeOptions()
	};

	// componentWillUpdate = ()=>{
	// 	console.log(this.props.id,"screener update")

	// };

	formatScreener = (s)=>{
		// const self = this
		//

		if(s){
			var rangeType = 2

			if(s.minVal === "" && s.maxVal === ""){
			    rangeType = 3
			}
			else if(s.maxVal === "" && s.minVal !== ""){
			    rangeType = 0
			}
			else if(s.maxVal !== "" && s.minVal === ""){
			    rangeType = 1
			}

			return {

				screener_name:s.field,
				min_value:s.minVal,
				max_value:s.maxVal,
				pos_type:s.pos_type,
				range_type: rangeType
			}
		}
	};

	onDelete =() =>{

		this.props.delete(this.props.screener);
	};

	duplicateScreener = () =>{

		this.props.duplicateScreener(this.state.screener);
	};

	removeSimilerScreeners = () =>{
		// TODO
		this.props.removeSimilerScreeners(this.state.screener)

	};

	changeBackgroundColor = () =>{
		// console.log("change color")
		if(this.props.screener.pos_type == 1){
			// styles.cardContentRow.backgroundColor = "white";
			styles.cardContentRow.borderLeft = "8px solid #f3354b";
			styles.dDown.iconColor.fill = "#f3354b"
		}

		else if(this.props.screener.pos_type == 0){
			// styles.cardContentRow.backgroundColor = "white";
			styles.cardContentRow.borderLeft = "8px solid #1bd824";
			styles.dDown.iconColor.fill = "#1bd824"

		}

		else{
			// styles.cardContentRow.backgroundColor = "white";
			styles.cardContentRow.borderLeft = "8px solid #4935f3";
			styles.dDown.iconColor.fill = "#4935f3"

		}
		// console.log(styles)
	}


	onChange = (event) => {
		const e = event;
		e.preventDefault();
		// console.log('onChange', e.target.value);
		this.props.screener[e.target.id] = e.target.value
		this.props.count()


		this.forceUpdate()
		// var screener = this.state.screener;

		// screener[e.target.id] = e.target.value;

		// console.log(screener);

		// this.setState({screener:screener});
		// this.onKeep();

	};

	onFieldSelect = (event, key, payload) => {
		// console.log('onDropDownSelect', key, payload)
		// var screener = this.state.screener;

		this.props.screener.field = payload;
		this.setPosTypeOptions()
		this.setSelectorTypeOptions()
		this.forceUpdate()
		this.props.count()

		// this.setState({screener:screener})
		this.setState({ currentField: payload })
		//console.log(screener)
		// this.onKeep();

	};
	onPosTypeSelect = (event, key, payload) => {
		// console.log('onPosTypeSelect', key, payload)
		// var screener = this.state.screener;
		this.props.screener.pos_type = payload;

		this.forceUpdate()
		// this.setState({screener:screener})
		// console.log(this.state.screener)
		// this.onKeep();
	};

	onSelectorTypeSelect = (event, key, payload) => {
		this.props.screener.selector = payload;

		this.forceUpdate()
	}

	showInfoText = (event) =>{
		event.preventDefault();
		console.log("show info")
		var popoverText = ""
		switch(this.props.screener.field){
			case "market_val":
				popoverText = (<span> Market capitalization refers the total dollar market value of a company's outstanding shares. <br/>Market cap is valued in thousand of dollars, example: Values of Min 2,000 and Max 10,000 will choose only companies with 2 - 10 Bill. </span>)
				break
			case "indexes":
				popoverText = (<span> Description coming soon...</span>)
				break
			case "moving_ave50":
				popoverText = (<span> Description coming soon...</span>)
				break
			case "beta":
				popoverText = (<span>Beta is a measure of the volatility, or systematic risk, of a security or a portfolio in comparison to the market as a whole. <br/>A beta of 1 indicates that the security's price moves with the market. <br/>A beta of less than 1 means that the security is theoretically less volatile than the market. A beta of greater than 1 indicates that the security's price is theoretically more volatile than the market.</span>)
				break
			case "volume":
				popoverText = (<span>
					Volume is the number of shares or contracts traded in a security or an entire market during a given period of time.
					<br/>
					Avg daily volume in last 20 days
					<br/>
					Volume is the number of shares or contracts traded in a security or an entire market during a given period of time.
				</span>)
				break
			case "last_price":
				popoverText = (<span>
					The last price at which a security traded, meaning the most recent price on which a buyer and seller agreed and at which some amount of the asset was transacted.
				</span>)
				break
			case "pe_ratio_12m":
				popoverText = (<span>
					The price-earnings ratio (P/E Ratio) is the ratio for valuing a company that measures its current share price relative to its per-share earnings.
				</span>)
				break
			case "iad":
				popoverText = (<span>
					The total dividends that would be paid on a share of stock throughout the next year if each dividend is the same amount as the previous payment.
				</span>)
				break
			case "avg_vol_20d":
				popoverText = (<span>
					Volume is the number of shares or contracts traded in a security or an entire market during a given period of time.
				</span>)
				break
			case "peg_ratio":
				popoverText = (<span>
					The price/earnings to growth ratio (PEG ratio) is a stock's price-to-earnings (P/E) ratio divided by the growth rate of its earnings for a specified time period. The PEG ratio is used to determine a stock's value while taking the company's earnings growth into account, and is considered to provide a more complete picture than the P/E ratio.
				</span>)
				break
		}

		this.setState({openPopover:true,anchorEl:event.target,popoverText:popoverText});


	};
	handlePopoverClose = () =>{
		this.setState({
		    openPopover: false,
		});
	}


	setFieldOptions = () =>{
		// console.log("dkjdkj")
		var validOptions = this.checkValidScreenerOptions()
		var screenerFields = []
		// console.log(validOptions)
		this.fieldNames = allScreenerFields.map(function(type){
			// console.log(type)
			var disabled = validOptions[type.type] ? false : true
			return <MenuItem disabled={disabled} key={type.type} id={type.type} value={type.type} primaryText={type.name} />
		});
		this.forceUpdate()
	}

	setSelectorTypeOptions = () => {
		let field = this.props.screener.field;
		let data = _.find(allScreenerFields, { type: field })
		if (data && data.selector && data.selector.length > 0) {
			console.log("XXX selector data", data.selector)
			this.props.screener.selector = data.selector[0].type;
			console.log("XXX updating screen with selector:", data.selector[0].type)
			this.setState({ screener: this.props.screener })
			// this.forceUpdate();
		}
	}

	setPosTypeOptions = () =>{
		var validOptions = this.checkValidScreenerOptions()
		console.log(validOptions)
		var disabledArray = []
		if(!validOptions[this.props.screener.field]){

			disabledArray = [-1,-1,-1]
		}else {
			disabledArray = validOptions[this.props.screener.field]
			if(disabledArray[0] == -1 || disabledArray[1] == -1){
				disabledArray.push(-1)
			}else{
				disabledArray.push(2)
			}
		}
		console.log(disabledArray)
		if(disabledArray[this.props.screener.pos_type] == -1){
			var firstGood = ""
			disabledArray.forEach(function(d){
				if(d != -1){
					firstGood = d
				}
			})
			this.props.screener.pos_type = firstGood
		}

		this.posTypeNames = posTypes.map(function(type){
			var disabled = disabledArray[type.type] == -1 ? true : false
			return <MenuItem disabled={disabled} key={type.type} id={type.type} value={type.type} primaryText={type.name} />
		});


		this.forceUpdate()

	}

	checkValidScreenerOptions = () =>{
		var availableOptions = cloneDeep(screenerFieldsFilter)
		let self =this
		// console.log("llililif")
		this.props.screeners.forEach(function(s,i){

			// console.log(i,self.props.id)
			if(!availableOptions[s.field]){
				// console.log(s.pos_type,s.field)
				// console.log('removedAlready')
			}
			else if(i == self.props.id) {
				// console.log("ignore myself")
			}
			else{

				if(s.pos_type == 0){
					availableOptions[s.field][0] = -1

				}else if(s.pos_type == 1){
					availableOptions[s.field][1] = -1

				}else if(s.pos_type == 2){

					availableOptions[s.field][0] = -1
					availableOptions[s.field][1] = -1
				}
				if(availableOptions[s.field].reduce((a, b) => a + b, 0) == -2){

					delete availableOptions[s.field]
				}
			}

		})
		return availableOptions
	}

	render(){

		// var posTypeNames = posTypes.map(function(type){
		// 	return <MenuItem key={type.type} id={type.type} value={type.type} primaryText={type.name} />
		// });
		let dDIconNode = <NavigationArrowDropDownCircle/>
		let dDColorIconNode = <FontIcon className="icon-dd" style={styles.dDown.icon}/>
		this.changeBackgroundColor()

		console.log("ScreenerToolBar props:", this.props)
		// const isIndexes = this.props.screener
		// 	&& this.props.screener.field
		// 	&& this.props.screener.field === 'indexes'
		//
		// this.indexesType = indexesType.map(t => {
		// 	return <MenuItem
		// 		key={t.type}
		// 		id={t.type}
		// 		value={t.type}
		// 		primaryText={t.name}
		// 		/>
		// })
		//

		// Set position type selector
		this.positionSelector = this.posTypeNames

		let hasSelector = false;
		let selectorValues = null;
		let currentFieldValue = this.props.screener.field || null;

		let notes = null

		console.log("CURRENT F VALUE:", currentFieldValue)
		if (currentFieldValue) {
			// Get the selector field if available
			let field = _.find(allScreenerFields, { type: currentFieldValue })
			console.log("FIELD X:", field)
			if (field && field.selector && field.selector.length > 0) {
				hasSelector = true;
				selectorValues = field.selector;
				console.log("SELECTOR VALUES:", selectorValues)
			}
			else if (field && field.posType) {
				if (field.posType.disabled) {
					let defaultPos = posTypes[0]
					if (_.has(field.posType, 'default')) {
						let temp = _.find(posTypes, { type: field.posType.default })
						if (temp) {
							defaultPos = temp
						}
					}

					// Field is disabled by definition
					this.positionSelector = [
						<MenuItem disabled={true}
							key={'__disabled'}
							id={defaultPos.type}
							value={defaultPos.type}
							primaryText={defaultPos.name} />
					]
				}
			}

			if (field && field.notes
				&& _.isString(field.notes)
				&& field.notes.length > 0) {

				notes = field.notes
			}

		}

		this.selectorType = hasSelector ? selectorValues.map(t => {
			return <MenuItem
				key={t.type}
				id={t.type}
				value={t.type}
				primaryText={t.name}
				/>
		}) : []

		return(
			<Paper className="screener-tb" zDepth={2}  style={styles.cardContentRow}>
			        <ToolbarGroup  style={styles.ToolbarGroup} firstChild={true}>

			        	{
			        		// <a onClick={this.showInfoText}><ActionInfo  style={styles.infoBtn} /></a>
			        	}
			        	<a onClick={this.showInfoText}>
			        		<FontIcon className="icon-info" style={styles.infoBtn}/>
			        	</a>

			            <DropDownMenu iconButton={dDIconNode} style={styles.dDown} labelStyle={styles.dDown.label} iconStyle={styles.dDown.icon}
			            				onClick={this.setFieldOptions} value={this.props.screener.field} onChange={this.onFieldSelect} >

				           {this.fieldNames}
			            </DropDownMenu>
			        </ToolbarGroup>

			        <ToolbarGroup  style={{...styles.ToolbarGroup, ...styles.ToolbarGroupPos}} firstChild={true}>
			            <DropDownMenu style={styles.dDownPos}
										labelStyle={styles.dDown.label}
										value={this.positionSelector && this.positionSelector.length > 1 ? this.props.screener.pos_type : (this.positionSelector && this.positionSelector[0] ? this.positionSelector[0].props.value : null)}
			            			iconStyle={{...styles.dDown.iconColor,...styles.dDown.icon}} onChange={this.onPosTypeSelect} iconButton={dDIconNode}>
				           {this.positionSelector}
			            </DropDownMenu>
			        </ToolbarGroup>

							{
								notes
								? (
									<ToolbarGroup onClick={this.setTypeOptions} style={{...styles.ToolbarGroup, ...styles.ToolbarGroupPos, width: '25%'}} firstChild={true}>
											{notes}
									</ToolbarGroup>
								) : (
									hasSelector
										? (
											<ToolbarGroup onClick={this.setTypeOptions} style={{...styles.ToolbarGroup, ...styles.ToolbarGroupPos}} firstChild={true}>
							            <DropDownMenu style={styles.dDownIndex} labelStyle={styles.dDown.labelBare} value={this.props.screener.selector}
							            			iconStyle={{...styles.dDown.iconColor,...styles.dDown.icon}} onChange={this.onSelectorTypeSelect} iconButton={dDIconNode}>
								           {this.selectorType}
							            </DropDownMenu>
							        </ToolbarGroup>
										)
										: (
											<div style={{display: 'flex'}}>
												<h5 style={styles.ToolbarLabel}>
							        		Min:
							        	</h5>
								        <ToolbarGroup style={styles.ToolbarGroupText} >

								        	<TextField id="minVal" onChange={this.onChange} style={styles.inputField}
								        	value={this.props.screener.minVal} disabled={(this.props.screener.val_type == 'only_max')}>
								        	</TextField>
								        </ToolbarGroup>
							         	<h5 style={styles.ToolbarLabel}>
							        		Max:
							        	</h5>
								        <ToolbarGroup style={styles.ToolbarGroupText} >

								        	<TextField id="maxVal" onChange={this.onChange} style={styles.inputField}
								        	disabled={(this.props.screener.val_type == 'only_min')} value={this.props.screener.maxVal}>
								        	</TextField>
								        </ToolbarGroup>
											</div>
										)
								)
							}


			        <div style={styles.flex3}></div>
			        <ToolbarGroup style={styles.ToolbarKeepBtn}  >
						<a style={styles.duplicateLink} onClick={this.duplicateScreener} >
							{/*<FontIcon className="icon-apply-all" style={styles.dupIconApply} />*/}
							<i className="material-icons" style={styles.dupIconApply}>check</i>
							<br/>
							Apply to all
						</a>
						<a style={styles.duplicateLink} onClick={this.removeSimilerScreeners} >
							{/*<FontIcon className="icon-reset-all" style={styles.dupIconRemove} />*/}
							<i className="material-icons" style={styles.dupIconRemove}>close</i>
							<br/>
							Remove from all
						</a>
						<IconButton iconStyle={iconStyles}  onClick={this.onDelete} >
							<FontIcon className="material-icons">close</FontIcon>
							<FontIcon className="icon-cross"/>
						</IconButton>
			        </ToolbarGroup>
			        <Popover
	                  open={this.state.openPopover}
	                  anchorEl={this.state.anchorEl}
	                  anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
	                  targetOrigin={{horizontal: 'left', vertical: 'top'}}
	                  onRequestClose={this.handlePopoverClose}
	                >

	                <div style={styles.popoverInner}>
	                	{this.state.popoverText}
	                </div>
	                </Popover>
			</Paper>);
	};
}



// WEBPACK FOOTER //
// ./src/js/components/ScreenerToolBar.js